import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../core/config/api.config';
import {INSTITUTE_SERVICE, STUDENT_SERVICE} from '../../core/config/api.constants';
import {endpoint} from '../path.constants';
import {ApiResponse} from '../api-response.model';
import {EnumData, InstituteType} from '../enum/enum.model';


@Injectable({providedIn: 'root'})
export class StudentsService {
    private readonly baseUrl = ApiConfig.getBaseUrl(STUDENT_SERVICE);

    constructor(private http: HttpClient) {
    }

    getStudentEnum() {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        return this.http.get<ApiResponse<{ enum_data: EnumData[] }>>(
            this.baseUrl + endpoint.student.enum, {headers}
        );
    }
}
